import * as React from "react";
import { HugeiconsIcon, type HugeiconsIconProps } from "@hugeicons/react";

// A bundler cannot split lib/icons.tsx, so importing one glyph from it loads all 214KB. Components
// on the critical path (toaster, menus, marketing header) use this factory instead.
export type IconProps = Omit<HugeiconsIconProps, "icon">;
export type LucideIcon = React.ComponentType<IconProps>;

// An icon with a name or role is the only thing saying what it means and stays readable; the rest
// are decoration. A caller's `aria-hidden` wins (spread after).
function decorative(props: IconProps): true | undefined {
  return props["aria-label"] || props["aria-labelledby"] || props.role ? undefined : true;
}

// No strokeWidth: glyphs carry their own, and pre-outlined fills (the clipboards) would draw at
// double weight.
export function icon(glyph: HugeiconsIconProps["icon"]): LucideIcon {
  const Component = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
    <HugeiconsIcon ref={ref} icon={glyph} aria-hidden={decorative(props)} {...props} />
  ));
  return Component as LucideIcon;
}
